import './VirusBanner.scoped.sass'
import { ReactComponent as VirusIcon } from '@/assets/icons/virus-solid.svg'

export function VirusBanner () {
  return <div className="virus-banner">
    <div className="icon">
      <VirusIcon />
    </div>
    <div className="message">
      <h1>This message seems dangerous</h1>
      <p>Our system detected this message might contain unsafe assets or content related with phishing or scam activities.</p>
    </div>
  </div>
}
